/**
 * @generated SignedSource<<1a347bb1efaf6ff1567fe6a8065ed248>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type scmpYoutubeContent$data = {
  readonly entityId: string;
  readonly publishedDate: number | null | undefined;
  readonly " $fragmentType": "scmpYoutubeContent";
};
export type scmpYoutubeContent$key = {
  readonly " $data"?: scmpYoutubeContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"scmpYoutubeContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "scmpYoutubeContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedDate",
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "f8fe4b2d7bcdd2c678d20232515f8d25";

export default node;
